module.exports = __webpack_public_path__ + "static/media/23n.e48b9328.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/23n.svg
// module id = 167
// module chunks = 0